/* TIRTIR gamified popup - loader.
   Install (theme.liquid, before </body>):
     <script>window.DISRUPT_POPUP={gameAsset:"{{ 'tirtir-game.js' | asset_url }}"};</script>
     (Klaviyo: klaviyoCompany = public site ID, klaviyoList = email list, klaviyoSmsList = SMS list.)
     <script src="{{ 'tirtir-popup.js' | asset_url }}" defer></script>
   The game payload is fetched only on pageviews that are going to show the popup,
   so it costs nothing on the others.

   The game runs in a full-viewport transparent iframe and lays out its own dialog
   (width, height, scrolling), so the popup always hugs the current screen of the game.
*/
(function () {
  "use strict";

  var D = window.DISRUPT_POPUP || {};
  var CFG = {
    enabled:        D.enabled !== false,
    gameAsset:      D.gameAsset      || null,
    delayMs:        D.delayMs        || 4000,
    minDelayMs:     D.minDelayMs     || 3000,
    // Extra triggers, whichever comes first with the timer (Matt, 6 Oct: 3 s felt too fast).
    scrollPercent:  Number(D.scrollPercent) > 0 && Number(D.scrollPercent) <= 100 ? Number(D.scrollPercent) : null,   // open once the visitor scrolls this far (after minDelayMs)
    exitIntent:     D.exitIntent === true,        // desktop only: open when the mouse leaves through the top of the window
    suppressDays:   D.suppressDays   || 7,
    replayTab:      D.replayTab !== false,
    alwaysShow:     D.alwaysShow === true,        // test mode: ignore all suppression
    excludePaths:   D.excludePaths   || ["/checkout", "/checkouts", "/cart", "/account", "/password", "/tools"],
    klaviyoCompany: D.klaviyoCompany || null,
    klaviyoList:    D.klaviyoList    || null,
    klaviyoSmsList: D.klaviyoSmsList || null,     // phone numbers join this list with SMS marketing consent
    source:         D.source         || "Gamified popup",
    smsLive:        D.smsLive === true,           // set only when a real service texts the code
    debug:          D.debug || /[?&]popupdebug=1/.test(location.search)
  };

  // Version 1 (default): one game, email only.
  // Version 2: after the email (10% code) the winner is offered an upgraded code (15%) for a phone number.
  // Set version:2 in DISRUPT_POPUP. With debug:true in the store config (not the ?popupdebug=1
  // logging switch), ?popupversion=1 or 2 in the URL overrides it for testing.
  // The older second game (pick a cushion for a free sample, then "text me the gift code") is still
  // in the game, switched off: sampleGame:true + phoneStep:true, or ?popupsample=1 when testing.
  var vq = D.debug === true ? /[?&]popupversion=([12])\b/.exec(location.search) : null;
  var sq = D.debug === true && /[?&]popupsample=1\b/.test(location.search);
  var VERSION = vq ? Number(vq[1]) : (D.version === 2 ? 2 : 1);
  var own = function (k, fallback) { return typeof D[k] === "boolean" && !vq && !sq ? D[k] : fallback; };
  var FEATURES = {
    phoneUpgrade: own("phoneUpgrade", !sq && VERSION === 2),
    sampleGame:   own("sampleGame", sq),
    phoneStep:    own("phoneStep", sq),
    winPercent:     Number(D.winPercent) > 0 ? Number(D.winPercent) : 10,
    upgradePercent: Number(D.upgradePercent) > 0 ? Number(D.upgradePercent) : 15
  };

  // Phone numbers are collected from US visitors only. On a real store (debug off) the offer is
  // skipped when Shopify reports another country; those visitors get the email-only flow.
  // Shopify.country is the visitor's country as Shopify sees it (location and their country selector).
  // Real store (debug off): the phone offer shows ONLY when that country is in the list; if Shopify
  // gives no country, it is hidden. Staging (debug:true): always shown, unless ?popupcountry=XX is
  // added to try another country.
  var cq = D.debug === true ? /[?&]popupcountry=([A-Za-z]{2})\b/.exec(location.search) : null;
  var country = cq ? cq[1].toUpperCase() : (window.Shopify && window.Shopify.country ? String(window.Shopify.country).toUpperCase() : null);
  var phoneCountries = D.phoneCountries || ["US"];
  if ((D.debug !== true || cq) && phoneCountries.indexOf(country) === -1) { FEATURES.phoneUpgrade = false; FEATURES.phoneStep = false; }
  FEATURES.country = country;

  // Sharing: the card links back to this store, and a visitor arriving on a shared link
  // (?beatMs=13430) is shown "Can you beat 13.43s?".
  var bq = /[?&]beatMs=(\d{3,7})\b/.exec(location.search);
  var bn = bq ? Number(bq[1]) : 0;
  FEATURES.beatMs = bn >= 500 && bn <= 3600000 ? bn : null;   // same bounds as the game
  FEATURES.shareUrl = D.shareUrl || (location.origin + "/");

  var K_DISMISS = "tirtir_popup_dismissed_until";
  var K_WON     = "tirtir_popup_won";
  var K_SHOWN   = "tirtir_popup_shown_session";
  var K_CHAL    = "tirtir_popup_challenge";        // the beatMs already shown in this tab
  var K_RESULT  = "tirtir_popup_result_session";   // this visit's win, so it can be shared from any page
  function challengeSeen() { try { return sessionStorage.getItem(K_CHAL) === String(FEATURES.beatMs); } catch (e) { return false; } }
  function saveResult(ms, claimed, upgrade) { try { sessionStorage.setItem(K_RESULT, JSON.stringify({ ms: ms, claimed: claimed, upgrade: upgrade || null })); } catch (e) {} }
  // Version 1 only: on a later page in the same visit, bring back the win (time, claimed or not) so
  // the tab still leads to the reward and "Share my result". No email is stored. Off in test mode,
  // where every load starts a fresh game, and off for a challenge link seen for the first time.
  (function () {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem(K_RESULT) || "null"); } catch (e) {}
    if (saved && !CFG.alwaysShow && !FEATURES.sampleGame && !(FEATURES.beatMs && !challengeSeen()) && saved.ms >= 500 && saved.ms <= 3600000)
      FEATURES.restore = { elapsedMs: Number(saved.ms), claimed: saved.claimed === true, upgrade: saved.upgrade === "upgraded" || saved.upgrade === "declined" ? saved.upgrade : null };
  })();
  var EMAIL_RE  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function log() { if (CFG.debug) try { console.log.apply(console, ["[tirtir-popup]"].concat([].slice.call(arguments))); } catch (e) {} }
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  // Matches whole path segments, so /cart and /en-us/cart are excluded but /collections/cartoon is not.
  function excluded() {
    var p = ((location.pathname || "").toLowerCase().replace(/\/+$/, "")) + "/";
    for (var i = 0; i < CFG.excludePaths.length; i++) {
      var x = String(CFG.excludePaths[i]).toLowerCase().replace(/\/+$/, "") + "/";
      if (p.indexOf(x) !== -1) return CFG.excludePaths[i];
    }
    return false;
  }
  function blocked() {
    if (!CFG.enabled) return "disabled";
    if (window.Shopify && window.Shopify.designMode) return "theme editor";
    if (!window.HTMLDialogElement || typeof window.HTMLDialogElement.prototype.showModal !== "function") return "no dialog support";
    var ex = excluded();
    return ex ? "excluded path " + ex : false;
  }
  function suppressedUntil() {
    var u = Number(get(K_DISMISS) || 0);
    return u && Date.now() < u ? u : 0;
  }
  function shouldAutoShow() {
    if (CFG.alwaysShow) { log("test mode: always show"); return true; }
    if (FEATURES.beatMs && !challengeSeen()) { log("challenge link: show"); return true; }
    if (get(K_WON))     { log("already won"); return false; }
    var s = suppressedUntil();
    if (s)              { log("suppressed until", new Date(s).toISOString()); return false; }
    try { if (sessionStorage.getItem(K_SHOWN)) { log("already shown this session"); return false; } } catch (e) {}
    return true;
  }

  /* ---------- lazy load of the game payload ---------- */
  var loading = null;
  function loadGame() {
    if (window.TIRTIR_GAME_HTML) return Promise.resolve(window.TIRTIR_GAME_HTML);
    if (loading) return loading;
    if (!CFG.gameAsset) return Promise.reject(new Error("no gameAsset configured"));
    loading = new Promise(function (res, rej) {
      var s = document.createElement("script");
      s.src = CFG.gameAsset;
      s.async = true;
      s.onload = function () { window.TIRTIR_GAME_HTML ? res(window.TIRTIR_GAME_HTML) : rej(new Error("asset loaded but payload missing")); };
      s.onerror = function () { loading = null; rej(new Error("failed to load game asset")); };
      document.head.appendChild(s);
    });
    return loading;
  }

  /* ---------- UI ---------- */
  var overlay = null, frame = null, tab = null;
  var open_ = false, ready = false, lastLead = null;
  var wonHere = !!FEATURES.restore, claimedHere = !!(FEATURES.restore && FEATURES.restore.claimed), lastWinMs = FEATURES.restore ? FEATURES.restore.elapsedMs : 0;
  var hideTimer = 0, readyTimer = 0, liveTimer = 0, revealTries = 0, lastFocus = null, savedOverflow = null;

  // Gotham Medium, letters only (about 4 KB), for the replay tab. Generated by build_fonts.py.
  // Licence: needs a Gotham web licence before use on a public store.
  var TAB_FONT = "data:font/woff2;base64,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";

  function css() {
    var s = document.createElement("style");
    s.textContent = [
      "@font-face{font-family:TirtirGothamTab;src:url('" + TAB_FONT + "') format('woff2');font-weight:400 700;font-display:swap}",
      ".tp-ovl{position:fixed;left:0;top:0;width:100%;height:100%;z-index:2147483000;margin:0;padding:0;",
      "background:rgba(32,20,14,.55);opacity:0;transition:opacity .25s ease;overscroll-behavior:contain}",
      ".tp-ovl{pointer-events:none}",                    // never block the page while fading out
      ".tp-ovl.tp-on{opacity:1;pointer-events:auto}",
      ".tp-ovl[hidden]{display:none!important}",
      ".tp-ovl iframe{position:absolute;left:0;top:0;width:100%;height:100%;border:0;margin:0;padding:0;display:block;",
      "background:transparent;color-scheme:light}",
      ".tp-ovl iframe{pointer-events:none}.tp-ovl.tp-live iframe{pointer-events:auto}",
      ".tp-tab{position:fixed;left:14px;bottom:14px;z-index:2147482900;border:0;border-radius:999px;padding:12px 17px;",
      "min-height:44px;background:#a9372c;color:#fff;font:500 13px/1 TirtirGothamTab,Gotham,Arial,Helvetica,sans-serif;cursor:pointer;",
      "box-shadow:0 6px 18px rgba(120,40,30,.35);-webkit-tap-highlight-color:transparent}",
      ".tp-tab:focus-visible{outline:2px solid #331a24;outline-offset:3px}",
      "@media(prefers-reduced-motion:reduce){.tp-ovl{transition:none}}"
    ].join("");
    document.head.appendChild(s);
  }

  function send(msg) {
    try { if (frame && frame.contentWindow) frame.contentWindow.postMessage(Object.assign({ __tirtir: 1 }, msg), "*"); } catch (e) {}
  }

  // Keep the game inside the visible area when a phone keyboard opens.
  function fit() {
    if (!overlay) return;
    var vv = window.visualViewport;
    var keyboard = vv && Math.abs(vv.scale - 1) < 0.02 && window.innerHeight - vv.height > 120;
    overlay.style.height = keyboard ? Math.round(vv.height) + "px" : "";
    overlay.style.top = keyboard ? Math.round(vv.offsetTop) + "px" : "";
  }

  function lockScroll(on) {
    var el = document.documentElement;
    if (on) {
      if (savedOverflow === null) savedOverflow = { o: el.style.overflow, p: el.style.paddingRight };
      var gap = window.innerWidth - el.clientWidth;
      el.style.overflow = "hidden";
      if (gap > 0) el.style.paddingRight = gap + "px";
    } else if (savedOverflow !== null) {
      el.style.overflow = savedOverflow.o;
      el.style.paddingRight = savedOverflow.p;
      savedOverflow = null;
    }
  }

  function gameUp() {
    try { var p = frame.contentDocument.getElementById("popup"); return !!(p && p.open); } catch (e) { return false; }
  }
  // Give the game keyboard focus without losing the element it focused itself. Focusing an iframe
  // from the page resets focus inside the frame to <body>, which dropped the heading on every open.
  function focusGame() {
    var doc = null, keep = null;
    try { doc = frame.contentDocument; keep = doc.activeElement; } catch (e) {}
    try { if (doc && keep && keep !== doc.body && doc.hasFocus()) return; } catch (e) {}
    try { frame.focus({ preventScroll: true }); } catch (e) {}
    try {
      if (!keep || keep === doc.body || !doc.contains(keep)) keep = doc.getElementById("popup-title");
      if (keep && doc.activeElement !== keep) keep.focus({ preventScroll: true });
    } catch (e) {}
  }
  // Dim the page only once the game's dialog is really open. If it never opens (script error,
  // blocked inline script) give up quietly instead of leaving the store dimmed and locked.
  function reveal() {
    if (!open_ || !overlay) return;
    clearTimeout(readyTimer);
    if (!gameUp()) {
      if (++revealTries > 60) { revealTries = 0; close("game-failed"); return; }
      readyTimer = setTimeout(reveal, 50);
      return;
    }
    revealTries = 0;
    overlay.classList.add("tp-on");
    focusGame();
    clearTimeout(liveTimer);
    liveTimer = setTimeout(function () {
      if (!open_ || !overlay) return;
      overlay.classList.add("tp-live");
      focusGame();   // the game's win hand-off needs focus inside
    }, 400);
  }

  function build(html) {
    overlay = document.createElement("div");
    overlay.className = "tp-ovl";
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Play to win a reward");

    frame = document.createElement("iframe");
    frame.title = "TIRTIR game";
    frame.setAttribute("allow", "clipboard-write");   // srcdoc is same-origin, so sharing needs no extra grant
    frame.setAttribute("allowtransparency", "true");
    // Hand the version switches to the game before any of its scripts run.
    var cfg = JSON.stringify(FEATURES).replace(/</g, "\\u003c");
    frame.srcdoc = html.replace("<head>", function () { return "<head><script>window.TIRTIR_CONFIG=" + cfg + ";<\/script>"; });

    overlay.appendChild(frame);
    document.body.appendChild(overlay);
    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", fit);
      window.visualViewport.addEventListener("scroll", fit);
    }
  }

  function open(reason) {
    if (open_) return;
    var why = blocked();
    if (why) { log("not opening:", why); return; }
    open_ = true;
    log("opening:", reason);
    loadGame().then(function (html) {
      if (!open_) return;
      try { sessionStorage.setItem(K_SHOWN, "1"); if (FEATURES.beatMs) sessionStorage.setItem(K_CHAL, String(FEATURES.beatMs)); } catch (e) {}
      clearTimeout(hideTimer);
      revealTries = 0;
      lastFocus = document.activeElement;
      lockScroll(true);
      if (tab) tab.style.display = "none";
      document.addEventListener("keydown", esc);
      if (!overlay) {
        build(html);
        // Fade in once the game says it is ready; never wait longer than 2s.
        readyTimer = setTimeout(reveal, 2000);
      } else {
        overlay.hidden = false;
        send({ type: "tirtir:open" });
        requestAnimationFrame(reveal);
      }
      fit();
      emit("open", { reason: reason });
    }).catch(function (err) { open_ = false; log("open failed:", err.message); });
  }

  function esc(e) { if (e.key === "Escape") close("escape"); }

  function close(reason) {
    if (!open_) return;
    open_ = false;
    log("close:", reason);
    clearTimeout(readyTimer);
    document.removeEventListener("keydown", esc);
    if (reason !== "game") send({ type: "tirtir:close-request" });   // let the game stop its timer and clear inputs
    if (overlay) {
      clearTimeout(liveTimer);
      overlay.classList.remove("tp-on", "tp-live");
      hideTimer = setTimeout(function () { if (!open_ && overlay) overlay.hidden = true; }, 260);
    }
    lockScroll(false);
    if (!get(K_WON)) set(K_DISMISS, String(Date.now() + CFG.suppressDays * 864e5));
    if (CFG.replayTab && reason !== "game-failed") showTab();
    try { if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true }); } catch (e) {}
    emit("close", { reason: reason });
  }

  function showTab() {
    if (!tab) {
      tab = document.createElement("button");
      tab.className = "tp-tab"; tab.type = "button";
      tab.onclick = function () { open("tab"); };
      document.body.appendChild(tab);
    }
    // Version 1 keeps the win for the rest of the visit (K_RESULT); otherwise a later page starts a new game.
    var upgrade = wonHere && lastLead && lastLead.tier !== "winner";   // claimed by skipping, then won: the win is not claimed yet
    tab.textContent = claimedHere && !upgrade ? "See your reward" : wonHere ? "Claim your reward" : "Play again";
    tab.style.display = "";
  }

  /* ---------- Klaviyo ---------- */
  function subscribe(lead, cb) {
    if (!CFG.klaviyoCompany || !CFG.klaviyoList) {
      log("KLAVIYO NOT CONFIGURED - would subscribe:", { email: lead.email, consent: lead.consent, tier: lead.tier, source: CFG.source });
      return cb(null, { simulated: true });
    }
    var profile = { email: lead.email, properties: { tirtir_popup_reward: lead.tier || "unknown" } };
    if (lead.consent) profile.subscriptions = { email: { marketing: { consent: "SUBSCRIBED" } } };
    var body = { data: { type: "subscription", attributes: {
      custom_source: CFG.source,
      profile: { data: { type: "profile", attributes: profile } }
    }, relationships: { list: { data: { type: "list", id: CFG.klaviyoList } } } } };
    klaviyo("subscriptions", body, cb);
  }

  // The game gives up on a claim after 12 s, so this call must fail before that.
  function klaviyo(endpoint, body, cb) {
    var ctrl = typeof AbortController === "function" ? new AbortController() : null;
    var giveUp = setTimeout(function () { if (ctrl) ctrl.abort(); }, 10000);
    fetch("https://a.klaviyo.com/client/" + endpoint + "/?company_id=" + encodeURIComponent(CFG.klaviyoCompany), {
      method: "POST",
      headers: { "content-type": "application/json", revision: "2026-07-15" },   // the subscriptions (consent) field needs 2025-01-15 or later
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) { clearTimeout(giveUp); log("klaviyo", endpoint, "status", r.status); cb(r.ok ? null : new Error("klaviyo " + r.status), { status: r.status }); })
      .catch(function (e) { clearTimeout(giveUp); log("klaviyo", endpoint, "error", e); cb(e); });
  }

  // QA 5: record which sample was won, so the email flow can honour it.
  function saveSample(gift) {
    emit("sample", { giftId: gift });
    if (!lastLead) return;
    if (!CFG.klaviyoCompany || !CFG.klaviyoList) { log("KLAVIYO NOT CONFIGURED - would save sample:", gift); return; }
    klaviyo("profiles", { data: { type: "profile", attributes: { email: lastLead.email, properties: { tirtir_popup_sample: gift } } } },
      function (err) { log("sample saved:", !err); });
  }

  // Phone number step. The game shows TIRTIR's SMS consent paragraph right under the button, so the
  // number joins the SMS list (klaviyoSmsList) with SMS marketing consent; the list's flow texts
  // the code. Without an SMS list the number is only saved on the profile, with no consent.
  function savePhone(phone, cb) {
    if (!CFG.klaviyoCompany || !CFG.klaviyoList) { log("KLAVIYO NOT CONFIGURED - would text the code to:", phone); return cb(null, { simulated: true }); }
    var attrs = { phone_number: phone, properties: { tirtir_popup_text_requested: true } };
    if (FEATURES.phoneUpgrade) attrs.properties.tirtir_popup_discount = FEATURES.upgradePercent;   // the flow sends the upgraded code
    if (lastLead) attrs.email = lastLead.email;
    if (!CFG.klaviyoSmsList) { klaviyo("profiles", { data: { type: "profile", attributes: attrs } }, cb); return; }
    attrs.subscriptions = { sms: { marketing: { consent: "SUBSCRIBED" } } };
    klaviyo("subscriptions", { data: { type: "subscription", attributes: {
      custom_source: CFG.source,
      profile: { data: { type: "profile", attributes: attrs } }
    }, relationships: { list: { data: { type: "list", id: CFG.klaviyoSmsList } } } } }, cb);
  }

  window.addEventListener("message", function (ev) {
    var d = ev.data;
    if (!d || d.__tirtir !== 1 || !frame || ev.source !== frame.contentWindow) return;
    if (d.type === "tirtir:ready")  { ready = true; log("game ready"); reveal(); return; }
    if (d.type === "tirtir:close")  { close("game"); return; }
    if (d.type === "tirtir:upgrade") {
      var st = d.state === "upgraded" || d.state === "declined" ? d.state : null;
      if (st && FEATURES.phoneUpgrade) { if (lastWinMs) saveResult(lastWinMs, true, st); emit("upgrade", { state: st }); }
      return;
    }
    if (d.type === "tirtir:phone" && !(FEATURES.phoneStep || FEATURES.phoneUpgrade)) { send({ type: "tirtir:phone:result", id: d.id, ok: false }); return; }
    if (d.type === "tirtir:phone") {
      var phone = String(d.phone || "").replace(/[\s().-]/g, "");
      if (!(FEATURES.phoneUpgrade ? /^\+1[2-9]\d{2}[2-9]\d{6}$/ : /^\+[1-9]\d{7,14}$/).test(phone)) { send({ type: "tirtir:phone:result", id: d.id, ok: false }); return; }
      emit("phone", { tier: d.rewardTier || null });
      savePhone(phone, function (err, res) {
        send({ type: "tirtir:phone:result", id: d.id, ok: !err, simulated: !CFG.smsLive || !!(res && res.simulated) });
      });
      return;
    }
    if (d.type === "tirtir:sample") { var gift = String(d.giftId || ""); if (FEATURES.sampleGame && /^[a-z0-9-]{1,40}$/.test(gift)) saveSample(gift); return; }
    if (d.type === "tirtir:result") { if (d.outcome === "won") { wonHere = true; lastWinMs = Number(d.elapsedMs) || 0; saveResult(lastWinMs, false); } log("result:", d.outcome, d.elapsedMs); emit("result", { outcome: d.outcome, elapsedMs: d.elapsedMs }); return; }
    if (d.type === "tirtir:lead") {
      var email = String(d.email || "").trim();
      if (!EMAIL_RE.test(email) || email.length > 254) { send({ type: "tirtir:lead:result", id: d.id, ok: false }); return; }
      var lead = { email: email, consent: d.marketingConsent === true, tier: d.rewardTier || null };
      log("lead:", lead.email, "consent:", lead.consent, "tier:", lead.tier);
      emit("lead", { email: lead.email, consent: lead.consent, tier: lead.tier });
      subscribe(lead, function (err, res) {
        if (!err) { claimedHere = true; lastLead = lead; set(K_WON, "1"); if (lead.tier === "winner" && lastWinMs) saveResult(lastWinMs, true); if (!open_ && tab) showTab(); }
        send({ type: "tirtir:lead:result", id: d.id, ok: !err, simulated: !!(res && res.simulated) });
        emit("subscribed", { ok: !err, detail: res, error: err && String(err) });
      });
    }
  });

  function emit(name, detail) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: "tirtir_popup_" + name, detail: detail }); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("tirtir:popup:" + name, { detail: detail })); } catch (e) {}
  }

  function boot() {
    css();
    window.TirtirPopup = {
      open: function () { open("manual"); },
      close: function () { close("manual"); },
      reset: function () { try { localStorage.removeItem(K_DISMISS); localStorage.removeItem(K_WON); sessionStorage.removeItem(K_SHOWN); sessionStorage.removeItem(K_CHAL); sessionStorage.removeItem(K_RESULT); } catch (e) {} log("state reset"); },
      state: function () { return { version: VERSION, features: FEATURES, open: open_, ready: ready, dismissedUntil: get(K_DISMISS), won: get(K_WON), blocked: blocked(), cfg: CFG }; }
    };
    var why = blocked();
    if (why) { log("not showing:", why); return; }
    if (!shouldAutoShow()) { if (CFG.replayTab) showTab(); return; }
    // A shared challenge link (?beatMs=) came to play: open at the minimum delay.
    var challenge = FEATURES.beatMs && !challengeSeen();
    var wait = challenge ? CFG.minDelayMs : Math.max(CFG.minDelayMs, CFG.delayMs);
    var early = !challenge && (CFG.scrollPercent || CFG.exitIntent);
    log("version", VERSION, FEATURES, "- opening in", wait, "ms", early ? { scrollPercent: CFG.scrollPercent, exitIntent: CFG.exitIntent } : "");
    var fired = false, started = 0, timer = null, startY = 0, scrolled = false, interacted = false;
    var INPUTS = ["wheel", "touchmove", "keydown", "mousedown"];   // the visitor scrolling (browser jumps to an anchor or a restored position do not count)
    function touched() { interacted = true; }
    // Shopify's cookie banner: the pop-up waits until the visitor has answered it (then a short moment more), but not
    // for ever. After wait + 12 s it opens anyway, above the banner (the banner is not modal and sits below the pop-up).
    var consentAnswered = false, settleUntil = 0;
    document.addEventListener("visitorConsentCollected", function () { consentAnswered = true; settleUntil = Date.now() + 1500; });
    function shown(id) { var el = document.getElementById(id); if (!el || !el.getClientRects().length) return false; var cs = window.getComputedStyle(el); return cs.display !== "none" && cs.visibility !== "hidden" && cs.opacity !== "0"; }
    function covered() {
      if (document.documentElement.hasAttribute("data-scroll-locked")) return true;   // theme drawer, menu, filters or quick-add (Broadcast)
      if (Date.now() < settleUntil) return true;
      if (consentAnswered || Date.now() - started >= wait + 12000) return false;
      if (shown("shopify-pc__banner") || shown("shopify-pc__prefs__dialog")) return true;
      // Banner still to come for a visitor who has not answered yet (Shopify's own test: region flag AND no answer).
      try {
        var cp = window.Shopify && window.Shopify.customerPrivacy, vc = cp && typeof cp.currentVisitorConsent === "function" ? cp.currentVisitorConsent() : null;
        if (vc && vc.marketing === "" && vc.analytics === "" && vc.preferences === "" && typeof cp.shouldShowBanner === "function" && cp.shouldShowBanner()) return true;
      } catch (e) {}
      return false;
    }
    function stop() {
      fired = true; clearTimeout(timer);
      window.removeEventListener("scroll", onScroll); document.removeEventListener("mouseout", onLeave);
      INPUTS.forEach(function (t) { window.removeEventListener(t, touched, true); });
    }
    function fire(reason) {
      if (fired) return;
      // Never on top of the cookie banner or the theme's open cart drawer, menu, filters or quick-add.
      if (covered()) {
        if (reason === "timer") timer = setTimeout(function () { fire("timer"); }, 1000);   // scroll and exit stay armed too
        return;
      }
      stop();
      if (shouldAutoShow()) open(reason); else if (CFG.replayTab) showTab();
    }
    function onScroll(e) {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (!interacted) { startY = y; return; }               // only the visitor's own scrolling counts, not a page that opened part-way down
      if (e && Math.abs(y - startY) > 10) scrolled = true;
      if (!scrolled || Date.now() - started < CFG.minDelayMs) return;
      var range = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0) - window.innerHeight;
      // scrollPercent of the page, or two screens down on long pages, whichever comes first
      if (range > 0 && y >= Math.min(range * CFG.scrollPercent / 100, 2 * window.innerHeight)) fire("scroll");
    }
    function onLeave(e) { if (Date.now() - started >= CFG.minDelayMs && !e.relatedTarget && e.clientY <= 0) fire("exit"); }
    // The clock starts when the visitor can see the tab (not in a background tab opened with cmd/ctrl-click).
    function arm() {
      started = Date.now(); startY = window.pageYOffset || document.documentElement.scrollTop || 0;
      // Warm the game file during the wait so the pop-up opens on time: after the page's own images, ready before the earliest open.
      setTimeout(function () { loadGame().catch(function () {}); }, early ? Math.max(0, CFG.minDelayMs - 500) : Math.max(0, wait - 2500));
      timer = setTimeout(function () { fire("timer"); }, wait);
      if (!early) return;
      if (CFG.scrollPercent) {
        INPUTS.forEach(function (t) { window.addEventListener(t, touched, { passive: true, capture: true }); });
        window.addEventListener("scroll", onScroll, { passive: true });
        setTimeout(onScroll, CFG.minDelayMs + 50);   // catches someone who scrolled far before minDelayMs
      }   // catches someone who scrolled far before minDelayMs
      if (CFG.exitIntent && window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches) document.addEventListener("mouseout", onLeave);
    }
    if (document.hidden) document.addEventListener("visibilitychange", function shown() { if (!document.hidden) { document.removeEventListener("visibilitychange", shown); arm(); } });
    else arm();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
